import { render, staticRenderFns } from "./Licenses.vue?vue&type=template&id=43e8d88a&scoped=true&"
import script from "./Licenses.vue?vue&type=script&lang=js&"
export * from "./Licenses.vue?vue&type=script&lang=js&"
import style0 from "./Licenses.css?vue&type=style&index=0&id=43e8d88a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e8d88a",
  null
  
)

export default component.exports